export const PROVIDER = {
  HOTMART: 'HOTMART',
  YOUTUBE: 'YOUTUBE',
  VIMEO: 'VIMEO'
};

export const VISIBILITY = {
  PUBLIC: 'PUBLIC',
  CLUB: 'CLUB',
  HOTMART: 'HOTMART',
  DEFAULT: 'DEFAULT',
  PRIVATE: 'PRIVATE'
};

export const STATUS = {
  CREATING: 'CREATING',
  CREATED: 'CREATED',
  STARTED: 'STARTED',
  CLOSING: 'CLOSING',
  COMPLETED: 'COMPLETED',
  DELETED: 'DELETED',
  FAILED: 'FAILED'
};

export const ENABLE_VOD = {
  YES: true,
  NO: false
};

export const ENABLE_VOD_OPTIONS = [
  {
    value: ENABLE_VOD.YES,
    label: 'general.yes'
  },
  {
    value: ENABLE_VOD.NO,
    label: 'general.no'
  }
];

export const PROVIDER_REGEX = {
  // eslint-disable-next-line no-useless-escape
  [PROVIDER.YOUTUBE]:
    '^$|^(((http|https)://)?(www.)?(youtube.com|youtu.be)/.+$)',
  // eslint-disable-next-line no-useless-escape
  [PROVIDER.VIMEO]: '^$|^((http|https)://)?(www.)?(vimeo.com/).+$'
};

export const FORM = {
  ID: 'live-form',
  FIELD: {
    TITLE: 'title',
    DESCRIPTION: 'description',
    URL: 'url',
    PROVIDER: 'provider',
    ENABLE_VOD_PLAYBACK: 'enableVodPlayback',
    ZONE_ID: 'zoneId',
    START_HOURS_MINUTES: 'startHoursMinutes',
    START_DATE: 'startDate',
    START_HOURS: 'startHours',
    START_MINUTES: 'startMinutes',
    THUMBNAIL: 'thumbnail',
    TAGS: 'tags',
    LANGUAGE: 'language',
    signLanguage: 'signLanguage'
  },
  ACTION_TYPES: {
    CREATE: 'create',
    UPDATE: 'update'
  }
};

export const URL_STATUS = {
  SUCCESS: 'success',
  ERROR: 'error',
  LOADING: 'busy'
};

export const CREATED_FROM = {
  HOTMART_CLUB: 'HOTMART_CLUB',
  HOTMART_CLUB_ONLINE_EVENT: 'HOTMART_CLUB_ONLINE_EVENT',
  CLUB: 'CLUB',
  ONLINE_EVENT: 'ONLINE_EVENT',
  SPARKLE: 'SPARKLE',
  WEBINAR: 'WEBINAR',
  ON_FIRE: 'ON_FIRE'
};

export const DESCRIPTION_MAX_LENGTH = 5000;

export const ERRORS = {
  NOT_FOUND: 'NOT_FOUND'
};
